
/**
 * Enriches strategy data with default values if needed
 * @param strategy Initial strategy data
 * @param originalStrategyId Optional original strategy ID
 * @returns Enriched strategy data with defaults for missing properties
 */
export const enrichStrategyData = (strategy: any, originalStrategyId?: string) => {
  if (!strategy) return null;
  
  return {
    ...strategy,
    id: strategy?.id || originalStrategyId,
    followers: strategy?.followers || 33,
    winRate: strategy?.winRate || 91,
    maxDrawdown: strategy?.maxDrawdown || 22.2,
    tradesWon: strategy?.tradesWon || 381,
    tradesLost: strategy?.tradesLost || 13,
    aum: strategy?.aum || 230131.94,
    description: strategy?.description || "Higher tier trading strategy",
    isPremium: true
  };
};

/**
 * Returns the premium advantages list
 * @returns Array of premium advantages as strings
 */
export const getPremiumAdvantages = () => [
  "Expertly Vetted – Each strategy is thoroughly reviewed by our team to ensure consistent performance.",
  "Strict Risk Standards – Premium strategies follow clear risk protocols, helping you trade with greater confidence.",
  "Premium Oversight – Continuous monitoring and updates maintain strategy quality over time.",
  "Subscription Access – Membership fees support ongoing verification and high service standards."
];
